(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define(
    "product-qty",
    class extends baseComponent.default {
      render() {
        this.currentVariant = +this.getAttribute("variant-id");
        this._bindStepper();
        this.listenTo("variantChange", (e, data) => {
          this.currentVariant = data.variant.id;
          this._rerender(data);
        });
        this.listenTo(
          "qtyStatusUpdate",
          (e, data) => {
            if (this.currentVariant === +data.variantId) {
              this._rerender(data);
            }
          },
          false,
        );
      }

      _bindStepper() {
        const minus = this.querySelector("[data-qty-minus]");
        const plus = this.querySelector("[data-qty-plus]");
        const input = this.querySelector('input[name="quantity"]');
        if (!minus || !plus || !input) return;

        minus.addEventListener("click", () => {
          const val = parseInt(input.value) || 1;
          if (val > 1) input.value = val - 1;
        });

        plus.addEventListener("click", () => {
          const val = parseInt(input.value) || 1;
          const max = parseInt(input.getAttribute("max")) || 10;
          if (val < max) input.value = val + 1;
        });
      }

      _rerender(data) {
        const source = data.html.querySelector("product-qty");
        const currentQty =
          this.querySelector('input[name="quantity"]')?.value || "1";
        this.replaceChildren(...source.cloneNode(true).childNodes);
        const newInput = this.querySelector('input[name="quantity"]');
        if (newInput) {
          const max = parseInt(newInput.getAttribute("max")) || 10;
          newInput.value = Math.min(parseInt(currentQty), max);
        }
        this._bindStepper();
      }
    },
  );
})();
